import type { LexicalEditor } from "lexical";
import { HeadingNode } from "@lexical/rich-text";
import { ListNode, ListItemNode } from "@lexical/list";
import { LinkNode } from "@lexical/link";

// Catches internal Lexical errors — not related to the `error` prop (form validation)
export function handleEditorError(error: Error, editor: LexicalEditor): void {
  console.error(error, editor);
}

// Node types the editor supports - add new types here to register them
export const editorNodes = [HeadingNode, ListNode, ListItemNode, LinkNode];
